import { Box, Skeleton, Text } from '@chakra-ui/react'
import React, { ReactElement } from 'react'
import { Table, TableColumn, TableRecord } from '@apex/component-library'

import { isEmpty } from 'lodash'
import moment from 'moment'

interface Props {
  tableData: TableRecord[] | []
  isLoading?: boolean
  hasReadPerm?: boolean
}

const inactiveColumns: TableColumn[] = [
  {
    key: 'date',
    label: 'Start Date',
    recordField: 'date',
    isSortable: true,
    cellRenderer: ({ value }) => <Box> {moment(value).format('M/D/YYYY')} </Box>
  },
  { key: 'schedule', label: 'Schedule', recordField: 'schedule', isSortable: false },
  { key: 'occurrences', label: 'Occurrences', recordField: 'occurrences', isSortable: false },
  { key: 'amount', label: 'Amount', recordField: 'amount', alignment: 'right', isSortable: false },
  { key: 'status', label: 'Status', recordField: 'status', alignment: 'right', isSortable: false }
]

export function InactiveScheduledTable({ tableData, isLoading, hasReadPerm }: Props): ReactElement {
  return (
    <>
      {!hasReadPerm && (
        <Box padding='5' minHeight='5'>
          <Text>Additional permissions are required to view this information</Text>
        </Box>
      )}

      {isEmpty(tableData) && !isLoading && hasReadPerm && (
        <Box minHeight='5' padding='5' borderBottom='1px'>
          <Text>There are no inactive transfer schedules</Text>{' '}
        </Box>
      )}

      {!isLoading && !isEmpty(tableData) && hasReadPerm && (
        <Table columns={inactiveColumns} data={tableData} size='md' data-testid='transfer-schedules-inactive-table' />
      )}
      {isLoading && (
        <Box>
          <Skeleton marginTop='5' h='20px' />
          <Skeleton marginTop='5' h='20px' />
        </Box>
      )}
    </>
  )
}
